<template>
  <div class="search-result-item">
    <div class="result-meta">
      <span class="result-id">#{{ data._id }}</span>
      <span class="breadcrumb" v-if="data._source.parent_name_txt">
        {{ data._source.parent_name_txt_zh || data._source.parent_name_txt }}
      </span>
    </div>

    <h3 class="result-title" @click="handleDetail">
      {{ data._source.name_txt_zh || data._source.name_txt }}
      <span class="latin-name-inline">{{ data._source.name_txt }}</span>
    </h3>

    <div class="result-snippet">
      <div class="taxonomy-tags">
        <template v-for="level in taxonomyLevels" :key="level.key">
          <span v-if="data._source[level.key]" class="tag-item">
            <span class="tag-label">{{ level.label }}:</span>
            <span class="tag-val">{{ data._source[level.key] }}</span>
          </span>
        </template>
      </div>
    </div>

    <div v-if="data._source.parent_name_txt" class="result-footer">
      归属于 <span class="highlight">{{ data._source.parent_name_txt }}</span> 的分类谱系
    </div>
  </div>
</template>

<script setup>
  import {  useRouter } from 'vue-router';
  const props = defineProps({
    data: { type: Object, required: true, default: () => ({}) }
  });

  const router = useRouter();


  const taxonomyLevels = [
    { label: '域 Superkingdom', key: 'superkingdom' },
    { label: '界 Kingdom', key: 'kingdom' },
    { label: '门 Phylum', key: 'phylum' },
    { label: '纲 Class', key: 'clas' },
    { label: '目 Order', key: 'orders' },
    { label: '科 Family', key: 'family' },
    { label: '属 Genus', key: 'genus' }
  ];


  const handleDetail = () => {
    // 模拟点击跳转或展开逻辑
    console.log('查看详情:', props.data);

    router.push({
      path: '/species',
      query: { database_name: props.data._index, id: props.data._id }
    });
  };
</script>

<style scoped>
  .search-result-item {
    width: 100%;
    padding: 12px 0;
    background: transparent;
    border: none;
    transition: all 0.2s ease;
    text-align: left;
  }

  .search-result-item:hover .result-title {
    text-decoration: underline;
  }

  .result-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #4d5156;
    margin-bottom: 4px;
  }

  .result-id {
    color: #70757a;
  }

  .breadcrumb {
    color: #202124;
  }

  .breadcrumb::before {
    content: "›";
    margin-right: 8px;
    color: #70757a;
  }

  .result-title {
    margin: 0 0 4px 0;
    font-size: 20px;
    font-weight: 400;
    color: #1a0dab;
    cursor: pointer;
    display: flex;
    align-items: baseline;
    gap: 10px;
    font-weight: 600;
  }

  .latin-name-inline {
    font-size: 14px;
    color: #70757a;
    font-style: italic;
    font-weight: normal;
    font-weight: 600;
  }

  /* 内容摘要区 */
  .result-snippet {
    font-size: 14px;
    line-height: 1.58;
    color: #4d5156;
    margin-bottom: 8px;
  }

  .taxonomy-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .tag-item {
    background: #f8f9fa;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #ebebeb;
    font-size: 12px;
  }

  .tag-label {
    color: #70757a;
    margin-right: 4px;
  }

  .tag-val {
    color: #202124;
    font-weight: 500;
  }

  /* 底部脚注 */
  .result-footer {
    font-size: 12px;
    color: #70757a;
  }

  .highlight {
    color: #1a0dab;
  }
</style>